import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import Breadcrumbs from '../../../../Shared/Components/Breadcrumbs'
import Layout from '../../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

const CatalogForm = ({ item, slug, typeLabel }) => {
    const { flash } = usePage().props
    const isEdit = Boolean(item)
    const [saving, setSaving] = useState(false)

    const form = useForm({
        name: item?.name || '',
        sort_order: item?.sort_order ?? 0,
        activo: item?.activo !== false,
    })

    const fieldError = (key) => {
        const e = form.errors[key]
        return Array.isArray(e) ? e[0] : e
    }

    const path = isEdit
        ? `admin/sia/manage/atencion-cliente/catalogos/${slug}/${item.id}/edit`
        : `admin/sia/manage/atencion-cliente/catalogos/${slug}/create`

    const submit = (e) => {
        e.preventDefault()
        setSaving(true)
        const opts = {
            preserveScroll: true,
            onFinish: () => setSaving(false),
        }
        const payload = {
            name: form.data.name,
            sort_order: Number(form.data.sort_order),
            activo: form.data.activo ? 1 : 0,
        }

        if (isEdit) {
            Inertia.post(route('customer-service.catalogs.update', [slug, item.id]), { _method: 'put', ...payload }, opts)
            return
        }

        Inertia.post(route('customer-service.catalogs.store', slug), payload, opts)
    }

    return (
        <Row>
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath={path} />
            </span>

            {flash?.success && <div className="alert alert-success mb-5">{flash.success}</div>}

            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-6">
                <h1 className="fs-2 fw-bold text-gray-900 mb-0">
                    {isEdit ? 'Editar' : 'Nuevo'} — {typeLabel}
                </h1>
                <Link href={route('customer-service.catalogs.index', slug)} className="btn btn-sm btn-light">
                    ← Volver al listado
                </Link>
            </div>

            <Card className="card-flush shadow-sm">
                <Card.Body className="py-8 px-6 px-lg-10">
                    <Form onSubmit={submit}>
                        <Row className="g-4 mb-4">
                            <Col md={8}>
                                <Form.Label className="fw-bold">Nombre</Form.Label>
                                <Form.Control
                                    value={form.data.name}
                                    onChange={(e) => form.setData('name', e.target.value)}
                                    className={fieldError('name') ? 'is-invalid' : ''}
                                />
                                {fieldError('name') && <div className="invalid-feedback d-block">{fieldError('name')}</div>}
                            </Col>
                            <Col md={4}>
                                <Form.Label className="fw-bold">Orden</Form.Label>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    value={form.data.sort_order}
                                    onChange={(e) => form.setData('sort_order', parseInt(e.target.value, 10) || 0)}
                                    className={fieldError('sort_order') ? 'is-invalid' : ''}
                                />
                                {fieldError('sort_order') && <div className="invalid-feedback d-block">{fieldError('sort_order')}</div>}
                            </Col>
                        </Row>
                        <Row className="g-4 mb-6">
                            <Col md={4}>
                                <Form.Check
                                    type="switch"
                                    id="activo"
                                    label="Activo"
                                    checked={form.data.activo}
                                    onChange={(e) => form.setData('activo', e.target.checked)}
                                />
                            </Col>
                        </Row>
                        <Button type="submit" variant="primary" disabled={saving || form.processing}>
                            {isEdit ? 'Guardar cambios' : 'Crear'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Row>
    )
}

CatalogForm.layout = (page) => <Layout title={page.props.typeLabel}>{page}</Layout>

export default CatalogForm
